import React from "react";
import { timeAgo } from "../data";

export default function Sidebar({ pages, currentPage, onNavigate, manifest, pipelineData }) {
  const errors = pipelineData?.errors?.length || 0;
  const changeCount = pipelineData?.changes_detected?.length || 0;
  const highPriority = (pipelineData?.changes_detected || []).filter(
    (c) => c.classification?.urgency === "immediate"
  ).length;

  const pipelineTime = manifest?.sources?.pipeline?.time || null;

  return (
    <aside className="w-56 bg-white border-r border-gray-200 flex flex-col shrink-0">
      {/* Brand */}
      <div className="px-5 py-5 border-b border-gray-100">
        <div className="flex items-center gap-2.5">
          <span className="text-xl">🌳</span>
          <div>
            <h1 className="font-bold text-base text-gray-900 leading-tight">Oak Intel</h1>
            <p className="text-[11px] text-gray-400">Competitor Monitor</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {pages.map(({ key, label, icon }) => {
          const isActive = currentPage === key;
          return (
            <button
              key={key}
              onClick={() => onNavigate(key)}
              className={`sidebar-link w-full ${
                isActive ? "sidebar-link-active" : "sidebar-link-default"
              }`}
            >
              <span className="text-base">{icon}</span>
              <span className="flex-1 text-left">{label}</span>
              {/* Mini badges */}
              {key === "changes" && highPriority > 0 && (
                <span className="badge badge-red text-[10px] px-1.5 py-0">{highPriority}</span>
              )}
              {key === "changes" && highPriority === 0 && changeCount > 0 && (
                <span className="badge badge-blue text-[10px] px-1.5 py-0">{changeCount}</span>
              )}
              {key === "dashboard" && errors > 0 && (
                <span className="badge badge-red text-[10px] px-1.5 py-0">!</span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Pipeline status footer */}
      <div className="px-4 py-3 border-t border-gray-100 space-y-1.5">
        <div className="flex items-center gap-1.5">
          <span
            className={`w-1.5 h-1.5 rounded-full ${
              pipelineTime
                ? Date.now() - new Date(pipelineTime).getTime() < 3600000
                  ? "bg-emerald-400"
                  : "bg-amber-400"
                : "bg-gray-300"
            }`}
          />
          <span className="text-[11px] text-gray-400">
            {pipelineTime ? `Pipeline ${timeAgo(pipelineTime)}` : "No data"}
          </span>
        </div>
        {pipelineData && (
          <div className="text-[11px] text-gray-400">
            {changeCount} change{changeCount !== 1 ? "s" : ""}
            {errors > 0 && ` · ${errors} error${errors !== 1 ? "s" : ""}`}
          </div>
        )}
        <p className="text-[10px] text-gray-300">Auto-refresh 60s</p>
      </div>
    </aside>
  );
}
